import PopOver from './PopOver';
import PopOverStye from './PopOverStyle';

export default class PopOverPlacement {

	constructor(arrowSize) {
		this.arrowSize = arrowSize;
		this.getCenteringOffset = this.getCenteringOffset.bind(this);
		this.getArrowCenteringOffset = this.getArrowCenteringOffset.bind(this);
		this.placeOnTop = this.placeOnTop.bind(this);
		this.placeOnBottom = this.placeOnBottom.bind(this);
		this.placeOnLeft = this.placeOnLeft.bind(this);
		this.placeOnRight = this.placeOnRight.bind(this);

		this.positions = {
			[PopOver.POSITION.TOP]: {
				position: PopOver.POSITION.TOP,
				func: this.placeOnTop,
				fits: (wrapperRect, popupRect) => (popupRect.height + this.arrowSize) < wrapperRect.top,
			},
			[PopOver.POSITION.BOTTOM]: {
				position: PopOver.POSITION.BOTTOM,
				func: this.placeOnBottom,
				fits: (wrapperRect, popupRect) => (popupRect.height + this.arrowSize) < (window.innerHeight - wrapperRect.bottom),
			},
			[PopOver.POSITION.LEFT]: {
				position: PopOver.POSITION.LEFT,
				func: this.placeOnLeft,
				fits: (wrapperRect, popupRect) => (popupRect.width + this.arrowSize) < wrapperRect.left,
			},
			[PopOver.POSITION.RIGHT]: {
				position: PopOver.POSITION.RIGHT,
				func: this.placeOnRight,
				fits: (wrapperRect, popupRect) => (popupRect.width + this.arrowSize) < (window.innerWidth - wrapperRect.right),
			},
		};

		this.positionsOrder = {
			[PopOver.POSITION.TOP]: [
				this.positions[PopOver.POSITION.TOP],
				this.positions[PopOver.POSITION.BOTTOM],
				this.positions[PopOver.POSITION.RIGHT],
				this.positions[PopOver.POSITION.LEFT],
			],
			[PopOver.POSITION.BOTTOM]: [
				this.positions[PopOver.POSITION.BOTTOM],
				this.positions[PopOver.POSITION.TOP],
				this.positions[PopOver.POSITION.RIGHT],
				this.positions[PopOver.POSITION.LEFT],
			],
			[PopOver.POSITION.LEFT]: [
				this.positions[PopOver.POSITION.LEFT],
				this.positions[PopOver.POSITION.RIGHT],
				this.positions[PopOver.POSITION.TOP],
				this.positions[PopOver.POSITION.BOTTOM],
			],
			[PopOver.POSITION.RIGHT]: [
				this.positions[PopOver.POSITION.RIGHT],
				this.positions[PopOver.POSITION.LEFT],
				this.positions[PopOver.POSITION.TOP],
				this.positions[PopOver.POSITION.BOTTOM],
			],
		};
	}

	/**
	 * Center popup horizontally on x-axis against wrapperRect
	 *
	 * @param originRect
	 * @param positionedRect
	 * @param axis string x|y
	 * @return int offset for x or y
	 */
	getCenteringOffset(originRect, positionedRect, axis) {
		let offset;

		if (axis === 'x') {
			offset = originRect.left + originRect.width / 2 - positionedRect.width / 2;

			// Prevent popup from positioning beyond right of viewport
			if (offset + positionedRect.width > window.innerWidth) {
				offset = originRect.right - positionedRect.width;
			}

			// Prevent popup from positioning beyond left of viewport
			if (offset < 0) {
				offset = 0;
			}
		} else if (axis === 'y') {
			// Center popup vertically on y-axis against wrapperRect
			offset = originRect.top;
			offset += originRect.height / 2;
			offset -= positionedRect.height / 2;
		}

		return offset;
	};

	getArrowCenteringOffset(wrapperRect, axis) {
		return (
			axis === 'x' ?
				wrapperRect.left + (wrapperRect.width / 2) - this.arrowSize :
				wrapperRect.top + (wrapperRect.height / 2) - this.arrowSize
		);
	};

	placeOnTop(wrapperRect, popupRect) {
		return new PopOverStye(
			PopOver.POSITION.TOP,
			wrapperRect.top - popupRect.height - this.arrowSize,
			this.getCenteringOffset(wrapperRect, popupRect, 'x'),
			wrapperRect.top - this.arrowSize,
			this.getArrowCenteringOffset(wrapperRect, 'x')
		);
	};

	placeOnBottom(wrapperRect, popupRect) {
		return new PopOverStye(
			PopOver.POSITION.BOTTOM,
			wrapperRect.bottom + this.arrowSize,
			this.getCenteringOffset(wrapperRect, popupRect, 'x'),
			wrapperRect.bottom,
			this.getArrowCenteringOffset(wrapperRect, 'x')
		);
	};

	placeOnLeft(wrapperRect, popupRect) {
		return new PopOverStye(
			PopOver.POSITION.LEFT,
			this.getCenteringOffset(wrapperRect, popupRect, 'y'),
			wrapperRect.left - popupRect.width - this.arrowSize,
			this.getArrowCenteringOffset(wrapperRect, 'y'),
			wrapperRect.left - this.arrowSize
		);
	};

	placeOnRight(wrapperRect, popupRect) {
		return new PopOverStye(
			PopOver.POSITION.RIGHT,
			this.getCenteringOffset(wrapperRect, popupRect, 'y'),
			wrapperRect.right + this.arrowSize,
			this.getArrowCenteringOffset(wrapperRect, 'y'),
			wrapperRect.right
		);
	};

	/**
	 * determine style positioning for placing the popOver
	 *
	 * @param defaultPosition string PopOver.POSITION... where it would be preferred to show the tool tip
	 * @param wrapperRect Rect of wrapper of popOver
	 * @param popupRect Rect of the actual popup
	 * @param arrowRect Rect of the arrow of the popup
	 * @return object PopOverStyle
	 */
	updatePopupOffsets(defaultPosition, wrapperRect, popupRect, arrowRect) {
		// based on desired position preference order, determine what position actually fits
		const fits = this.positionsOrder[defaultPosition].filter(position => position.fits(wrapperRect, popupRect));

		// if nothing fits, default to top
		const fit = fits.length ? fits[0] : this.positions[PopOver.POSITION.TOP];

		// determine bounds for the fitted popup
		return fit.func(wrapperRect, popupRect, arrowRect);
	};
}
